// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container.MuiContainer-root {
  padding: 4rem 20%;
}

.login-container form {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 2rem;
  padding: 2rem;
}

.login-header.MuiTypography-root {
  font-size: 36px;
  font-weight: 700;
  text-align: center;
  margin: 1rem 0;
}

@media screen and (max-width: 600px) {
  .login-container.MuiContainer-root {
    padding: 4rem 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/auth/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".login-container.MuiContainer-root {\n  padding: 4rem 20%;\n}\n\n.login-container form {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 2rem;\n  padding: 2rem;\n}\n\n.login-header.MuiTypography-root {\n  font-size: 36px;\n  font-weight: 700;\n  text-align: center;\n  margin: 1rem 0;\n}\n\n@media screen and (max-width: 600px) {\n  .login-container.MuiContainer-root {\n    padding: 4rem 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
